import React from "react";
import { useSelector } from "react-redux";
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';

export default function Header(props) {

    const corpname = useSelector(state => state.user.corpname);
    const account = useSelector(state => state.user.account);
    const accountnm = useSelector(state => state.user.name);
    const storagename = useSelector(state => state.form.storagename);
    const storageupdate = useSelector(state => state.form.storageupdate);


    return (
        <div>
            <div style={{ width: '100%', height: '55px' }}>
                <div style={{ position: 'absolute', top: 2, left: 5 }} >
                    <IconButton aria-label="メニュパネル表示" onClick={props.menuClick} title={"メニュ"}>
                        <Icon>more_vert</Icon>
                    </IconButton>
                </div>
                <div style={{ marginLeft: 0, marginTop: 0 }}>
                    <h2 style={{ padding: '13px 20px 20px 20px', borderBottom: '1px solid rgba(0, 0, 0, .1)', boxShadow:'rgba(255, 255, 255, .3)0 1px 0' }}>
                        {/*<span className="categoryfont" style={{ fontSize: 20 }}>{props.category}</span>*/}
                        <span id="webtitle" style={{ fontSize: 15, marginLeft: 30, fontWeight: 500 }}>{props.title}</span>
                    </h2>
                    <div style={{ position: 'absolute', right: 50, top: 5 }}>
                        <div style={{ textAlign: 'right'}}>
                            <span className="categoryfont" style={{ fontSize: 12, color: '#ccc' }}>user</span>
                            <span style={{ fontSize: 12, marginLeft: 10 }}>{corpname}</span>
                            <span className="categoryfont" style={{ fontSize: 12, color: '#ccc', marginLeft:30 }}>account</span>
                            <span style={{ fontSize: 12, marginLeft: 10 }}>{account}</span>
                            <span style={{ marginLeft: 10, fontSize: 12 }}>{accountnm}</span>
                        </div>
                    </div>
                    {storagename.length===0?null:
                    <div style={{ position: 'absolute', left: '45%', top: 20 }}>
                            <div className="strheaderthema" style={{ fontSize: 14, padding: '0 10px' }}>
                                <IconButton size="small" onClick={props.close} title={"閉じる"}>
                                    <Icon style={{ color: '#eee' }}>disabled_by_default</Icon>
                                </IconButton>
                                <span style={{padding:'0 5px'}}>{storagename}</span>
                                {storageupdate ?
                                    <React.Fragment>
                                    <IconButton size="small" onClick={()=>props.storageaction('update')} style={{ marginLeft:20 }} title={"付箋の更新"}>
                                        <Icon style={{ color: '#fff' }}>save_as</Icon>
                                    </IconButton> 
                                        <IconButton size="small" onClick={() => props.storageaction('delete')} style={{ marginLeft: 5 }} title={"明細削除"}>
                                        <Icon style={{ color: '#fff' }}>delete</Icon>
                                    </IconButton>
                                    </React.Fragment>
                                    : null
                                }
                                <IconButton size="small" onClick={() => props.storageaction('share')} style={{ marginLeft: 5 }} title={"共有設定の確認および更新"}>
                                    <Icon style={{ color: '#fff' }}>share</Icon>
                                </IconButton>
                            </div>
                        </div>
                    }

                {/*    <div style={{ position: 'absolute', right: 10, top: 10}}>*/}
                {/*        <div style={{ textAlign: 'right' }}>*/}
                {/*            <IconButton onClick={props.showsearchpanel} title={"設定"} >*/}
                {/*                <Icon>settings</Icon>*/}
                {/*            </IconButton>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                </div>
            </div>
         </div>
    );
}